<script>
    export let progress = 0;
</script>
<div id="progress">
    <svg class="m-auto" viewBox="0 50 89 50" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' class="grey stroke-1 stroke-shade" style="stroke-linecap: round;transform: translate(5px, 5px);" d="M0,90 A40,40 0 1,1 80,90" />
        <path fill='none' class="blue stroke-2 stroke-secondary" style="stroke-linecap: round;transform: translate(5px, 5px);stroke-dasharray: 128;stroke-dashoffset:{128*(1-progress)};" d="M0,90 A40,40 0 1,1 80,90" />
    </svg>
</div>